import React from 'react';

const MediaContent = () => {
  return (
    <section id="media-content" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Visual Stories of Change</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto mb-6"></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Text Content */}
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                At My Action for the Disabled Foundation (MAD Foundation), every initiative, event, and milestone is a step toward a more inclusive society. Our media gallery showcases photos and videos that reflect the impact of our programs, the dedication of our volunteers, and the achievements of persons with disabilities.
              </p>
              
             

              
            </div>

            {/* Media Visual */}
            <div className="space-y-6">
              <div className="relative">
                <img 
                  src="https://voh-buckets.s3.ap-south-1.amazonaws.com/stage/1756594516748%3A0.3202124103576207.png" 
                  alt="MAD Foundation community event showcasing inclusive activities"
                  className="w-full h-64 object-cover rounded-2xl shadow-lg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg font-bold">Community Engagement</h3>
                  <p className="text-sm text-gray-200">Inclusive events and workshops</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaContent;